module.exports = __webpack_public_path__ + "images/ccc0c1fb3914dababeadea52f532907c.png";